module.exports = __webpack_public_path__ + "static/media/scroll.38c5e319.png";